import RAGInitializer from 'components/RAGInitialiser/RAGInitializer';
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isDossierSelected, setIsDossierSelected] = useState(false);

  const toggleDossierSelection = () => {
    setIsDossierSelected((prev) => !prev);
  };

  return (
    <AppContext.Provider value={{ isDossierSelected, toggleDossierSelection }}>
      {/* Initialiser le service RAG au démarrage */}
      <RAGInitializer />
      
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};